export const SCORE_TYPES = {
  POSITIVE: 1,
  NEGATIVE: -1,
  NEUTRAL: 0,
}

export const FILTER_TYPES = {
  POSITIVE: 'positive',
  NEGATIVE: 'negative',
  COMMENTS: 'comments',
  ALL: '',
}

export const VALIDATION_RULES = {
  COMMENT_MIN_LENGTH: 3,
  POSITIVE_REVIEW_MIN_LENGTH: 0,
  NEGATIVE_REVIEW_MIN_LENGTH: 3,
  MAX_LENGTH: 1000,
}
